<!-- 能耗预警界面 -->
<template>
  <div class="access-record-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="能耗预警设置" name="first">
        <!--主页面 -->
        <div class="flex-row" style="height: 100%">
          <div class="flex-auto flex-valign" style="overflow: hidden">
            <!-- 右侧表格 -->
            <div class="section-main_table">
              <ioc-table ref="energyTable" :data="energyTableData" :option="energyTableOption" :page="energyPage"
                @row-cancle="closeDialog" @search-change="searchEnergyResult" @search-reset="resetEnergyQuery"
                @current-change="selectEnergyPage" @size-change="changeEnergySize"
                @selection-change="handleEnergySelectionChange">
                <!-- 表格搜索条件 自定义 -->
                <template slot="search_buildName">
                  <div>
                    <el-select v-model="energySearchParams.buildId" placeholder="请选择建筑名称" clearable>
                      <el-option v-for="item in buildOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <!-- 上方按钮 -->
                <template slot="menuLeft">
                  <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                    @click="handleAddEnergyAlarm">
                    新增
                  </el-button>
                  <el-button size="small" icon="el-icon-delete" class="iss-operation-button"
                    @click="handelDelEnergyAlarms" :disabled="!checkedEnergyAlarmIds.length">
                    批量删除
                  </el-button>
                </template>
                <!-- 自定义操作列 -->
                <template slot="menu" slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="iconfont icon-xiugai"
                      @click="handleEditEnergyAlarm(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="iconfont icon-shanchu"
                      @click="handleDelEnergyAlarm(scope.row, scope.index)"></el-button>
                  </el-tooltip>
                </template>
              </ioc-table>
            </div>
          </div>
          <!-- 新增/修改 -->
          <appPanel :width="700" class="app-panel" :isExpand="isAlarmExpand" @cancel="handleCloseAddOrEditEnergyAlarm"
            :title="energyTitle">
            <!-- 内容区域 -->
            <div class="question-box">
              <el-form style="height: 99%; position: absolute; width: 99%" :inline="true" :model="quesFromInfo"
                :rules="quesFromRule" ref="quesFrom" label-width="96px" label-position="right" label-suffix=" ：">
                <el-scrollbar style="height: 100%">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="预警名称" prop="earlyWarningName">
                        <el-input v-model="quesFromInfo.earlyWarningName" placeholder="请输入预警名称" clearable />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="建筑名称" prop="buildId">
                        <el-select v-model="quesFromInfo.buildId" placeholder="请选择" clearable
                          @change="queryBuildEnergyConsumption">
                          <el-option v-for="item in buildOptions" :key="item.value" :label="item.label"
                            :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="存储种类" prop="saveType">
                        <el-select v-model="quesFromInfo.saveType" placeholder="请选择" clearable>
                          <el-option label="冻鱼" :value="0" />
                          <el-option label="冻肉" :value="1" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="预警阀值" prop="threshold">
                        <el-input-number v-model="quesFromInfo.threshold" placeholder="请输入预警阀值" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="周期" prop="dates">
                        <el-date-picker v-model="quesFromInfo.dates" type="daterange" value-format="yyyy-MM-dd"
                          @change="queryBuildEnergyConsumption" style="width: 400px" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="同期能耗" prop="stThreshold">
                        <el-input v-model="quesFromInfo.stThreshold" type="daterange" disabled />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-scrollbar>
              </el-form>
            </div>

            <!-- 按钮区域 -->
            <span slot="footer" class="dialog-footer">
              <el-button @click="handleCloseAddOrEditEnergyAlarm" type="info" :loading="subLoading">
                取消
              </el-button>
              <el-button type="primary" :loading="subLoading" @click="handleSaveAddOrEditEnergyAlarm">
                {{ subLoading ? "提交中" : "确定" }}
              </el-button>
            </span>
          </appPanel>
        </div>

        <!-- 新增/修改 -->
      </el-tab-pane>

      <el-tab-pane label="谷峰平预警设置" name="second">
        <!--主页面 -->
        <div class="flex-row" style="height: 100%">
          <div class="flex-auto flex-valign" style="overflow: hidden">
            <!-- 右侧表格 -->
            <div class="section-main_table">
              <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
                @search-change="searchResult" @search-reset="resetQuery" @current-change="selectPage"
                @size-change="changeSize" @selection-change="handleSelectionChange">
                <!-- 表格搜索条件 自定义 -->
                <!-- 年度 -->
                <template slot="search_year">
                  <el-date-picker v-model="searchParams.year" type="year" value-format="yyyy" placeholder="请选择年度">
                  </el-date-picker>
                </template>

                <!-- 建筑-->
                <!-- <template slot="search_buildId">
                  <div>
                    <el-select v-model="searchParams.buildId" clearable placeholder="请选择建筑物名称">
                      <el-option v-for="item in buildOptions" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </template> -->
                <!-- 上方按钮 -->
                <template slot="menuLeft">
                  <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus"
                    @click="handleAddGfpAlarm">
                    新增
                  </el-button>
                  <el-button size="small" icon="el-icon-delete" class="iss-operation-button" @click="handelDelGfpAlarms"
                    :disabled="!checkedGfpAlarmIds.length">
                    批量删除
                  </el-button>
                </template>
                <!-- 自定义操作列 -->
                <template slot="menu" slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="iconfont icon-xiugai" @click="handleEditGfpAlarm(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="iconfont icon-shanchu"
                      @click="handleDelGfpAlarm(scope.row, scope.index)"></el-button>
                  </el-tooltip>
                </template>
              </ioc-table>
            </div>
          </div>
        </div>

        <!-- 新增/修改 -->
        <appPanel :width="1200" class="app-panel" :isExpand="showAddOrEditGfpAlarm" @cancel="handleCloseAddOrEditGfpAlarm"
          :title="gfpTitle">
          <!-- 内容区域 -->
          <el-form style="height: 99%; position: absolute; width: 99%" :inline="true" :model="threeFromInfo"
            :rules="threeFromRule" ref="threeFrom" label-width="90px" label-position="right" label-suffix=" ：">
            <el-scrollbar style="height: 100%">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="年份" prop="year">
                    <el-date-picker v-model="threeFromInfo.year" type="year" value-format="yyyy" placeholder="选择年" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="月" prop="month">
                    <el-select v-model="threeFromInfo.month" placeholder="请选择" clearable multiple>
                      <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                  <el-form-item label="建筑名称" prop="buildId">
                    <el-select v-model="threeFromInfo.buildId" placeholder="请选择" clearable>
                      <el-option v-for="item in buildOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-table :data="threeFromInfo.energyVfpConsumptionWarningInfos" style="width: 100%; height: 500px">
                  <el-table-column prop="type" label="谷峰平">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.type">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="开始时段">
                    <template slot-scope="scope">
                      <el-time-select placeholder="开始时段" v-model="scope.row.startTime" style="width: 150px"
                        :picker-options="{ start: '00:00', end: '24:00', step: '01:00' }" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="结束时段">
                    <template slot-scope="scope">
                      <el-time-select placeholder="结束时段" v-model="scope.row.endTime" style="width: 150px" :picker-options="{
                        start: '00:00',
                        end: '24:00',
                        step: '01:00',
                        minTime: scope.row.startTime,
                      }" />
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="type" label="阈值">
                    <template slot-scope="scope">
                      <el-input-number v-model="scope.row.threshold" />
                    </template>
                  </el-table-column> -->
                  <el-table-column prop="type" label="电价">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.electrovalence" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="操作">
                    <template slot-scope="scope">
                      <el-button type="text" icon="el-icon-setting" style="font-size: 20px;"
                        @click="configShow(scope.$index)"></el-button>
                      <el-button v-if="scope.$index >= 2" type="text" icon="el-icon-circle-plus-outline"
                        style="font-size: 20px;" @click="handleAddRow(scope.$index)" />
                      <el-button v-if="scope.$index >= 3" type="text" icon="el-icon-remove-outline"
                        style="font-size: 20px;" @click="handleRemoveRow(scope.$index)" />
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-scrollbar>
          </el-form>

          <!-- 按钮区域 -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseAddOrEditGfpAlarm" type="info" :loading="subLoading">
              取消
            </el-button>
            <el-button type="primary" :loading="subLoading" @click="handleSaveAddOrEditGfpAlarm">
              {{ subLoading ? "提交中" : "确定" }}
            </el-button>
          </span>
        </appPanel>
        <el-dialog title="预警配置" :visible.sync="warningVisible" append-to-body :close-on-click-modal="warningModalClose"
          width="38%">
          <div style="height: 400px; overflow-y: auto;">
            <el-table :data="configInfos" style="width: 100%;">
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column prop="type" label="建筑名称">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.buildId" placeholder="请选择建筑" clearable>
                    <el-option v-for="item in buildOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="阈值">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.threshold" placeholder="请输入阈值" clearable />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" icon="el-icon-circle-plus-outline" style="font-size: 20px;"
                    @click="handleConfigAddRow(scope.$index)" />
                  <el-button v-if="scope.$index >= 1" type="text" icon="el-icon-remove-outline" style="font-size: 20px;"
                    @click="handleConfigRemoveRow(scope.$index)" />
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="configClose">取 消</el-button>
            <el-button type="primary" @click="configConfirm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/foreWarningTable";
import { energyTableOption } from "../config/energyForeWarningTable";

export default {
  components: {
    appPanel,
  },
  data() {
    return {
      isAlarmExpand: false,
      activeName: "first",
      // 能耗预警
      energyTableOption: energyTableOption(),
      energyPage: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      energyTableData: [],
      energySearchParams: {
        buildId: "",
        earlyWarningName: "",
      },
      // 能耗预警 新增/修改
      checkedEnergyAlarmIds: [],
      // 新增/修改表格
      energySubLoading: false,
      energyTitle: "",
      showAddOrEditEnergyAlarm: false,

      // 谷峰平预警
      tableOption: tableOption(),
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {
        year: "",
        buildId: "",
      },

      // 选择的id
      checkedGfpAlarmIds: [],
      // 新增/修改表格
      subLoading: false,
      gfpTitle: "",
      showAddOrEditGfpAlarm: false,
      quesFromInfo: {
        id: null,
        dates: [],
        buildId: null,
        stThreshold: null,
        buildName: "",
        creator: "",
        earlyWarningName: "",
        endTime: "",
        saveType: null,
        startTime: "",
        threshold: null,
      },
      quesFromRule: {
        buildId: [
          {
            required: true,
            message: "请选择建筑",
            trigger: ["change"],
          },
        ],
        earlyWarningName: [
          {
            required: true,
            message: "请输入预警名称",
            trigger: ["blur"],
          },
        ],
        saveType: [
          {
            required: true,
            message: "请选择存储种类",
            trigger: ["change"],
          },
        ],
        dates: [
          {
            required: true,
            message: "请选择周期",
            trigger: ["change"],
          },
        ],
        threshold: [
          {
            required: true,
            message: "请输入预警阀值",
            trigger: ["blur"],
          },
        ],
      },
      buildOptions: [],
      monthOptions: [
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
      ],
      typeList: [
        { label: "谷", value: 0 },
        { label: "平", value: 1 },
        { label: "峰", value: 2 },
      ],
      threeFromInfo: {
        id: null,
        creator: "",
        year: "",
        month: [],
        buildId: null,
        energyVfpConsumptionWarningInfos: [
          {
            electrovalence: 0,
            endTime: "",
            startTime: "",
            threshold: null,
            type: 0,
            list: []
          },
          {
            electrovalence: 0,
            endTime: "",
            startTime: "",
            threshold: null,
            type: 1,
            list: []
          },
          {
            electrovalence: 0,
            endTime: "",
            startTime: "",
            threshold: null,
            type: 2,
            list: []
          },
        ],
      },
      threeFromRule: {
        year: [
          {
            required: true,
            message: "请选择年",
            trigger: ["change"],
          },
        ],
        month: [
          {
            required: true,
            message: "请选择月",
            trigger: ["change"],
          },
        ],
        buildId: [
          {
            required: true,
            message: "请选择建筑",
            trigger: ["change"],
          },
        ],
      },
      warningVisible: false,
      warningModalClose: false,
      configInfos: [{
        buildId: "",
        threshold: ""
      }],
      dataFlag: null,
      dataTemp: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {};
    },
  },
  mounted() {
    this.getList();
    this.getEnergyList();
    this.queryBuildList();
  },
  methods: {
    configShow(index) {
      if (this.threeFromInfo.energyVfpConsumptionWarningInfos[index].list.length > 0) {
        this.configInfos = this.threeFromInfo.energyVfpConsumptionWarningInfos[index].list
      } else {
        this.configInfos = [{
          buildId: "",
          threshold: ""
        }]
      }
      this.dataFlag = index
      this.dataTemp = JSON.parse(JSON.stringify(this.threeFromInfo.energyVfpConsumptionWarningInfos[index].list))
      this.warningVisible = true
    },
    configClose() {
      this.configInfos = [{
        buildId: "",
        threshold: ""
      }]
      this.threeFromInfo.energyVfpConsumptionWarningInfos[this.dataFlag].list = this.dataTemp
      this.warningVisible = false
    },
    configConfirm() {
      this.threeFromInfo.energyVfpConsumptionWarningInfos[this.dataFlag].list = this.configInfos
      this.warningVisible = false
    },
    handleConfigAddRow(index) {
      this.configInfos.splice(index + 1, 0, {
        buildId: "",
        threshold: ""
      });
    },
    handleConfigRemoveRow(index) {
      this.configInfos.splice(index, 1);
    },
    handleAddRow(index) {
      this.threeFromInfo.energyVfpConsumptionWarningInfos.splice(index + 1, 0, {
        electrovalence: 0,
        endTime: "",
        startTime: "",
        threshold: null,
        type: null,
        list: []
      });
    },
    handleRemoveRow(index) {
      this.threeFromInfo.energyVfpConsumptionWarningInfos.splice(index, 1);
    },
    async queryBuildEnergyConsumption() {
      if (
        this.quesFromInfo.buildId === null ||
        this.quesFromInfo.dates === null ||
        this.quesFromInfo.dates.length === 0
      ) {
        return;
      }
      const { success, returnObj } = await this.$fetch(
        api.forewarning.getBuildEnergyConsumption +
        "?buildId=" +
        this.quesFromInfo.buildId +
        "&startTime=" +
        this.quesFromInfo.dates[0] +
        "&endTime=" +
        this.quesFromInfo.dates[1]
      );
      if (success) {
        this.quesFromInfo.stThreshold = returnObj;
      }
    },
    async queryBuildList() {
      const { success, returnObj } = await this.$fetch(api.display.getBuildList);
      if (success) {
        this.buildOptions = returnObj.map((v) => {
          return {
            label: v.name,
            value: v.id,
          };
        });
      }
    },
    handleTabClick(tab, event) { },

    // TODO获取列表
    getList() {
      this.$fetch(api.forewarning.queryEnergyVfpConsumptionWarningList, {
        ...this.searchParams,
        pageNum: this.energyPage.currentPage,
        pageSize: this.energyPage.pageSize,
      }).then((res) => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        }
      });
    },
    // 获取能耗列表
    getEnergyList() {
      this.$fetch(api.forewarning.queryEnergyConsumptionWarningList, {
        ...this.energySearchParams,
        pageNum: this.energyPage.currentPage,
        pageSize: this.energyPage.pageSize,
      }).then((res) => {
        if (res.success) {
          this.energyTableData = res.returnObj.list;
          this.energyPage.total = res.returnObj.total;
        }
      });
    },

    closeDialog() { },

    // 能耗预警相关
    searchEnergyResult(param) {
      // console.log("---能耗查询--param:--", param);
      this.energySearchParams.earlyWarningName = param?.earlyWarningName;
      this.energyPage.currentPage = 1;
      this.getEnergyList();
    },
    // 重置按钮
    resetEnergyQuery() {
      // console.log("---重置----", this.energySearchParams);
      this.energySearchParams.buildId = "";
      this.energySearchParams.earlyWarningName = "";
      this.getEnergyList();
    },
    // 点击上一页下一页按钮
    selectEnergyPage(val) {
      this.energyPage.currentPage = val;
      this.getEnergyList();
    },
    // 修改每页数据数量
    changeEnergySize(val) {
      this.energyPage.currentPage = 1;
      this.energyPage.pageSize = val;
      this.getEnergyList();
    },
    handleEnergySelectionChange(items) {
      if (!items || !items.length) {
        this.checkedEnergyAlarmIds = [];
      } else {
        this.checkedEnergyAlarmIds = items.map((item) => {
          return item.id;
        });
      }
    },

    // 查询按钮事件
    searchResult(param) {
      console.log("---查询--param:--", param);
      // this.searchParams = param;
      console.log("---查询--this.searchParams:--", this.searchParams);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      // console.log("---重置--this.searchParams:--", this.searchParams);
      this.searchParams.year = "";
      this.searchParams.buildId = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSelectionChange(items) {
      // console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedGfpAlarmIds = [];
      } else {
        this.checkedGfpAlarmIds = items.map((item) => {
          return item.id;
        });
      }
      // console.log("----this.checkedGfpAlarmIds:---", this.checkedGfpAlarmIds);
    },
    // 能耗预警
    handleAddEnergyAlarm() {
      // console.log("新增能耗预警");
      this.energyTitle = "新增能耗预警";
      this.isAlarmExpand = true;
    },
    handleCloseAddOrEditEnergyAlarm() {
      this.quesFromInfo.id = null;
      this.$refs.quesFrom.resetFields();
      this.isAlarmExpand = false;
    },
    handelDelEnergyAlarms() {
      // console.log("批量删除操作");
      this.$confirm("您确定批量删除选择的能耗预警吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(
          api.forewarning.removeEnergyConsumptionWarning,
          this.checkedEnergyAlarmIds
        ).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getEnergyList();
        });
      });
    },
    handleEditEnergyAlarm(row, index) {
      // console.log("--能耗修改()--row:--", row);
      this.quesFromInfo = JSON.parse(JSON.stringify(row));
      if (this.quesFromInfo.startTime) {
        this.quesFromInfo.dates = [
          this.quesFromInfo.startTime,
          this.quesFromInfo.endTime,
        ];
      }
      this.energyTitle = "修改能耗预警";
      this.isAlarmExpand = true;
    },
    handleDelEnergyAlarm(row) {
      // console.log("单个删除操作");
      this.$confirm("您确定删除该能耗预警信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.forewarning.removeEnergyConsumptionWarning, [row.id]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getEnergyList();
          }
        );
      });
    },
    handleSaveAddOrEditEnergyAlarm() {
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      this.$refs.quesFrom.validate((valid) => {
        if (valid) {
          let params = { ...this.quesFromInfo };
          if (this.quesFromInfo.dates && this.quesFromInfo.dates.length > 0) {
            params.startTime = this.quesFromInfo.dates[0];
            params.endTime = this.quesFromInfo.dates[1];
          }
          // console.log("参数@@##", this.userInfo)
          params.creator = this.userInfo.account
          // console.log("参数@@##", params)
          if (params.id) {
            // 修改
            this.$fetch(api.forewarning.editEnergyConsumptionWarning, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error("修改失败");
                } else {
                  this.$message.success("修改成功！");
                  // 关闭弹窗
                  this.handleCloseAddOrEditEnergyAlarm();
                  // 刷新列表数据
                  this.getEnergyList();
                }
              }
            );
          } else {
            // 新增
            this.$fetch(api.forewarning.addEnergyConsumptionWarning, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error("新增失败");
                } else {
                  this.$message.success("新增成功！");
                  // 关闭弹窗
                  this.handleCloseAddOrEditEnergyAlarm();
                  // 刷新列表数据
                  this.getEnergyList();
                }

              }
            );
          }
        } else {
          return false;
        }
      });
    },
    // 新增操作
    handleAddGfpAlarm() {
      // console.log("新增谷峰平预警");
      this.gfpTitle = "新增谷峰平预警";
      this.showAddOrEditGfpAlarm = true;
    },
    // 批量删除操作
    handelDelGfpAlarms() {
      // console.log("批量删除操作");
      this.$confirm("您确定批量删除选择的谷峰平预警吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(
          api.forewarning.removeEnergyVfpConsumptionWarning,
          this.checkedGfpAlarmIds
        ).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList();
        });
      });
    },
    // 编辑操作
    handleEditGfpAlarm(row, index) {
      // console.log("--修改()--row:--", row);
      this.gfpTitle = "修改谷峰平预警";
      this.threeFromInfo = JSON.parse(JSON.stringify(row));
      this.threeFromInfo.month = this.threeFromInfo.month.split(",");
      this.threeFromInfo.year = this.threeFromInfo.year + "";
      this.showAddOrEditGfpAlarm = true;
    },

    // 单个删除操作
    handleDelGfpAlarm(row) {
      // console.log("单个删除操作");

      this.$confirm("您确定删除该谷峰平预警信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.forewarning.removeEnergyVfpConsumptionWarning, [row.id]).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 关闭新增/修改 弹窗
    handleCloseAddOrEditGfpAlarm() {
      // TODO处理from表单取消校验操作
      this.threeFromInfo.id = null;
      this.threeFromInfo.energyVfpConsumptionWarningInfos = [
        {
          electrovalence: 0,
          endTime: "",
          startTime: "",
          threshold: null,
          type: 0,
          list: []
        },
        {
          electrovalence: 0,
          endTime: "",
          startTime: "",
          threshold: null,
          type: 1,
          list: []
        },
        {
          electrovalence: 0,
          endTime: "",
          startTime: "",
          threshold: null,
          type: 2,
          list: []
        },
      ];
      this.$refs.threeFrom.resetFields();
      this.showAddOrEditGfpAlarm = false;
    },
    // 保存新增/修改 弹窗
    handleSaveAddOrEditGfpAlarm() {
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      this.$refs.threeFrom.validate((valid) => {
        if (valid) {
          let params = { ...this.threeFromInfo };
          params.month =
            this.threeFromInfo.month.length > 0 ? this.threeFromInfo.month.join(",") : "";
          params.creator = this.userInfo.account
          if (params.id) {
            // 修改
            this.$fetch(api.forewarning.editEnergyVfpConsumptionWarning, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.returnObj);
                } else {
                  this.$message.success("修改成功！");
                  // 关闭弹窗
                  this.handleCloseAddOrEditGfpAlarm();
                  // 刷新列表数据
                  this.getList();
                }
              }
            );
          } else {
            // 新增
            this.$fetch(api.forewarning.addEnergyVfpConsumptionWarning, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.returnObj);
                } else {
                  this.$message.success("新增成功！");
                  // 关闭弹窗
                  this.handleCloseAddOrEditGfpAlarm();
                  // 刷新列表数据
                  this.getList();
                }
              }
            );
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  width: 100%;
  height: 82vh;
}

::v-deep .el-tab-pane {
  height: 100%;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}

.question-detail-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .detail-chart-box {
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: row;

    .chart-left-box {
      width: 280px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;

      // flex: 1;
      .left-content-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: calc(100% - 42px);
      }
    }

    .chart-right-box {
      width: calc(100% - 320px);
      margin-left: 40px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;
    }
  }

  .detail-table-box {
    width: 100%;
    height: calc(100% - 220px);
  }
}
</style>

<style scoped>
::v-deep.el-picker-panel {
  width: 37vw;
}

::v-deep .el-date-picker .el-picker-panel__content {
  width: 34vw;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #c0c4cc;
}
</style>
